module.exports = __webpack_public_path__ + "img/scan.956082db.gif";